import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "start-group__content" }
const _hoisted_2 = { class: "start-group__header" }

import type { Conversation } from '../types/index.ts'

import { showError } from '@nextcloud/dialogs'
import { t } from '@nextcloud/l10n'
import { provide, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import NcButton from '@nextcloud/vue/components/NcButton'
import NcPopover from '@nextcloud/vue/components/NcPopover'
import IconAccountMultiplePlusOutline from 'vue-material-design-icons/AccountMultiplePlusOutline.vue'
import NewConversationContactsPage from './NewConversationDialog/NewConversationContactsPage.vue'
import { ATTENDEE, CONVERSATION } from '../constants.ts'


export default /*@__PURE__*/_defineComponent({
  __name: 'ExtendOneToOneDialog',
  props: {
    token: {},
    container: {}
  },
  setup(__props: any) {

const props = __props

const store = useStore()
const router = useRouter()

const selectedParticipants = ref(getArrayWithSecondAttendee(props.token))
provide('selectedParticipants', selectedParticipants)

const lockedParticipants = ref(getArrayWithSecondAttendee(props.token))
provide('lockedParticipants', lockedParticipants)

// Add a visual bulk selection state for SelectableParticipant component
provide('bulkParticipantsSelection', true)

watch(() => props.token, (newValue) => {
	selectedParticipants.value = getArrayWithSecondAttendee(newValue)
	lockedParticipants.value = getArrayWithSecondAttendee(newValue)
})

/**
 * Returns second attendee of 1-1 conversation as SelectableParticipant-compatible object
 *
 * @param token - conversation token
 */
function getArrayWithSecondAttendee(token: string) {
	const conversation = store.getters.conversation(token) as Conversation | undefined
	if (!conversation || conversation.type !== CONVERSATION.TYPE.ONE_TO_ONE) {
		return []
	}
	return [{ id: conversation.name, source: ATTENDEE.ACTOR_TYPE.USERS, label: conversation.displayName }]
}

/**
 * Add current participants and selected ones to the new conversation
 */
async function extendOneToOneConversation() {
	try {
		const newConversation = await store.dispatch('extendOneToOneConversation', {
			token: props.token,
			newParticipants: selectedParticipants.value,
		})
		if (newConversation) {
			await router.push({ name: 'conversation', params: { token: newConversation.token } })
		}
	} catch (error) {
		console.error('Error creating new conversation: ', error)
		showError(t('spreed', 'Error while creating the conversation'))
	}
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NcPopover), {
    container: __props.container,
    "popup-role": "dialog",
    "close-on-click-outside": ""
  }, {
    trigger: _withCtx(() => [
      _createVNode(_unref(NcButton), {
        variant: "tertiary",
        title: _unref(t)('spreed', 'Start a group conversation'),
        "aria-label": _unref(t)('spreed', 'Start a group conversation')
      }, {
        icon: _withCtx(() => [
          _createVNode(IconAccountMultiplePlusOutline, { size: 20 })
        ]),
        _: 1
      }, 8, ["title", "aria-label"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h5", _hoisted_2, _toDisplayString(_unref(t)('spreed', 'Start a group conversation')), 1),
        _createVNode(NewConversationContactsPage, {
          "selected-participants": selectedParticipants.value,
          "onUpdate:selectedParticipants": _cache[0] || (_cache[0] = ($event: any) => ((selectedParticipants).value = $event)),
          class: "start-group__contacts",
          token: __props.token,
          "only-users": ""
        }, null, 8, ["selected-participants", "token"]),
        _createVNode(_unref(NcButton), {
          class: "start-group__action",
          variant: "primary",
          disabled: !selectedParticipants.value.length,
          onClick: extendOneToOneConversation
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('spreed', 'Create conversation')), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    _: 1
  }, 8, ["container"]))
}
}

})